import AdminRoleList from 'components/Admin/Role/List/AdminRoleList';
import React from 'react';

const AdminRolePageList = () => {
	return <AdminRoleList />;
};

export default AdminRolePageList;
